export interface Review {
  id: string;
  customerName: string;
  procedure: string;
  category: 'sac' | 'kalici-makyaj' | 'lazer-epilasyon' | 'cilt-bakimi' | 'genclesme' | 'solaryum' | 'bolgesel-incelme' | 'tirnak-bakimi' | 'kafa-masaji';
  rating: number;
  comment: string;
  thumbnailUrl: string;
  videoUrl: string;
  date: string;
  location: string;
  instagramUrl?: string;
  originalPrice: number;
  campaignPrice: number;
  campaignTag: string;
  packageIncludes: string[];
  campaignDescription?: string;
}

export function getInstagramShortcode(url: string): string | null {
  const match = url.match(/instagram\.com\/(?:p|reel)\/([A-Za-z0-9_-]+)/);
  return match ? match[1] : null;
}

export function getInstagramThumbnail(shortcode: string): string {
  return `https://www.instagram.com/p/${shortcode}/media/?size=m`;
}

export function getInstagramEmbedUrl(shortcode: string): string {
  return `https://www.instagram.com/p/${shortcode}/embed/captioned/`;
}

export const categories: { id: string; label: string; icon: string }[] = [
  { id: 'all', label: 'Tümü', icon: 'ri-apps-line' },
  { id: 'sac', label: 'Saç', icon: 'ri-scissors-line' },
  { id: 'kalici-makyaj', label: 'Kalıcı Makyaj', icon: 'ri-palette-line' },
  { id: 'lazer-epilasyon', label: 'Lazer Epilasyon', icon: 'ri-flashlight-line' },
  { id: 'cilt-bakimi', label: 'Cilt Bakımı', icon: 'ri-leaf-line' },
  { id: 'genclesme', label: 'Gençleşme', icon: 'ri-sparkling-line' },
  { id: 'solaryum', label: 'Solaryum', icon: 'ri-sun-line' },
  { id: 'bolgesel-incelme', label: 'Bölgesel İncelme', icon: 'ri-body-scan-line' },
  { id: 'tirnak-bakimi', label: 'Tırnak Bakımı', icon: 'ri-brush-line' },
  { id: 'kafa-masaji', label: 'Kafa Masajı', icon: 'ri-heart-pulse-line' },
];

export const reviews: Review[] = [
  {
    id: '9',
    customerName: 'Şeniz Hanım',
    procedure: 'Solaryum Seansı',
    category: 'solaryum',
    rating: 5,
    comment: 'Kışın bronz tenimi korumak için SaloonS solaryumunu kullanıyorum. Cihazlar çok modern, hijyen koşulları mükemmel. Tek seansta bile güzel bir renk aldım. Gözlük ve krem desteğiyle güvenle bronzlaşıyorum. Tek eksik kahve olsa süper olur!',
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/121d660c0a09266a44c7e404f57ff4ff.png',
    videoUrl: '',
    date: '2026-06-01',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DadhI3Jsr76/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Solaryum Kampanyası',
    packageIncludes: ['50 Dakika Solaryum: 1500 TL', '100 Dakika Solaryum: 2500 TL', "Satın aldığınız paketleri 31 Aralık'a kadar dilediğiniz zaman kullanabilirsiniz!"],
    campaignDescription: "SALOONS'TA SOLARYUM KAMPANYASI BAŞLADI! ☀️\uD83D\uDC8E\n\nErgoline marka muazzam Alman teknolojisiyle, canınız acımadan mükemmel bir bronzluğa kavuşun.\n\n\uD83D\uDD25 Sınırlı Süreye Özel Fiyatlar:\n\n50 Dakika Solaryum: 1500 TL\n\n100 Dakika Solaryum: 2500 TL\n(Satın aldığınız paketleri 31 Aralık'a kadar dilediğiniz zaman kullanabilirsiniz!)",
  },
  {
    id: '14',
    customerName: 'Ilgın Hanım',
    procedure: 'Solaryum Seansı',
    category: 'solaryum',
    rating: 5,
    comment: 'SaloonS güzellik salonunun solaryum bölümünde muazzam bir deneyim yaşadım. Cihazlar son teknoloji, hijyen konusunda çok titizler. İlk seanstan itibaren cildimde eşit ve doğal bir bronz ton oluştu. Personel çok ilgili ve her zaman yardımcı oluyor. Kozyatağı metro yakınında olması da ulaşımı çok kolaylaştırıyor!',
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/785f098685690a9986d09b9a79e14b3d.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaaSa2mMqLW/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Solaryum Kampanyası',
    packageIncludes: ['50 Dakika Solaryum: 1500 TL', '100 Dakika Solaryum: 2500 TL', "Satın aldığınız paketleri 31 Aralık'a kadar dilediğiniz zaman kullanabilirsiniz!"],
    campaignDescription: "SALOONS'TA SOLARYUM KAMPANYASI BAŞLADI! ☀️\uD83D\uDC8E\n\nErgoline marka muazzam Alman teknolojisiyle, canınız acımadan mükemmel bir bronzluğa kavuşun.\n\n\uD83D\uDD25 Sınırlı Süreye Özel Fiyatlar:\n\n50 Dakika Solaryum: 1500 TL\n\n100 Dakika Solaryum: 2500 TL\n(Satın aldığınız paketleri 31 Aralık'a kadar dilediğiniz zaman kullanabilirsiniz!)",
  },
  {
    id: '15',
    customerName: 'Ebru Hanım',
    procedure: 'Kaş Microblading Kalıcı Makyaj',
    category: 'kalici-makyaj',
    rating: 5,
    comment: "SaloonS Güzellik'te microblading yaptırdım ve sonuç inanılmaz! Kıl tekniği sayesinde kaşlarım tamamen doğal görünüyor, kendi kılınızdan ayırt edemeyeceksiniz. Steril koşullarda, profesyonel ellerde hiç ağrı hissetmedim. Altın oran ölçümüyle yüz hattıma en uygun şekil verildi. Sabah kalktığımda hazır kaşlarla güne başlamak paha biçilmez!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/1137f6119eacb1f9485bc96fc5e435bd.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaYWxwiskMk/',
    originalPrice: 0,
    campaignPrice: 2499,
    campaignTag: '15. Yıla Özel Microblading Kampanyası',
    packageIncludes: ['Microblading Kıl Tekniği', '1 Ay İçindeki Rötuş Dahil', 'Altın Oran Ölçümü', 'Steril Uygulama Ortamı'],
    campaignDescription: "SaloonS Güzellik'te 15. Yıla Özel Efsane Microblading Kampanyası! ⭐✨\n\nHer sabah kaş kalemiyle uğraşmaya, simetriyi tutturmaya çalışmaya son! Doğal kendi kaş kılınızdan ayırt edemeyeceğiniz kusursuz Microblading Kıl Tekniği uygulamamız şimdi çok özel bir fiyatla sizi bekliyor.\n\n\uD83D\uDED1 Sürpriz Ücret Yok, Net Fiyat:\n\nUygulama: Microblading Kıl Tekniği + 1 Ay İçindeki Rötuş Dahil\n\nKampanya Fiyatı: Sadece 2499 TL!\n\nYüz hattınıza en uygun altın oran ölçümüyle, tamamen steril koşullarda hayal ettiğiniz dolgun ve doğal kaşlara kavuşun. \uD83D\uDC8E",
  },
  {
    id: '16',
    customerName: 'Hülya Hanım',
    procedure: 'İpek Kirpik',
    category: 'kalici-makyaj',
    rating: 5,
    comment: 'İpek kirpik uygulaması yaptırdım ve gözlerim tamamen değişti! Doğal kirpiklerime hiç zarar vermeden, hafif ve ipeksi dokulu kirpikler eklendi. Sabah kalktığımda hazır makyajlı gözlerle güne başlıyorum, rimel sürmeye gerek kalmıyor. Uzman teknik sayesinde hiç rahatsızlık hissetmedim, kirpiklerim hafif ve doğal duruyor. Gerçekten profesyonel bir işçilik!',
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/df35530547a86ba81d0668ba13417ada.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaYSUdls08i/',
    originalPrice: 0,
    campaignPrice: 800,
    campaignTag: 'İpek Kirpik Kampanyası',
    packageIncludes: ['İpek Kirpik Uygulaması', 'Doğal ve Hafif Dokulu Kirpikler', 'Kirpik Uzunluk ve Kıvrımlık Seçenekleri', 'Profesyonel Uzman Teknik'],
    campaignDescription: "SaloonS Güzellik'te İpek Kirpik Uygulaması! ✨\n\nGözlerinize anında derinlik ve çekicilik katan, doğal kirpiklerinize zarar vermeyen ipek kirpik uygulamamız şimdi çok özel bir fiyatla!\n\n\uD83D\uDC8E Kaliteli ve Hafif Materyal:\nPremium ipek kirpikler, göz yapınıza en uygun uzunluk ve kıvrımlılık seçenekleriyle tamamen kişiselleştirilmiş uygulama.\n\n\uD83D\uDCA1 Neden İpek Kirpik?\n- Sabah kalktığınızda hazır makyajlı gözler\n- Rimel ve kirpik kıvırıcıya veda edin\n- Doğal kirpiklerinize hiç zarar vermez\n- Hafif ve konforlu, hissetmeyeceksiniz\n- Dayanıklı ve uzun ömürlü sonuç\n\n\uD83D\uDD25 Kampanya Fiyatı: 800 TL'den Başlayan Fiyatlarla!\n\nUzman estetisyenlerimiz tarafından, hijyenik koşullarda ve özenle uygulanır. Gözlerinizin güzelliğini bir üst seviyeye taşıyın!",
  },
  {
    id: '17',
    customerName: 'Demet Hanım',
    procedure: 'Kaş Microblading',
    category: 'kalici-makyaj',
    rating: 5,
    comment: "SaloonS Güzellik salonunda microblading yaptırdım ve sonuçtan çok memnun kaldım! Doğal kıl tekniğiyle kaşlarım tamamen değişti, herkes çok beğeniyor. Steril ortamda, profesyonel ekip tarafından yapılan işlem sırasında hiç ağrı hissetmedim. Sabahları artık kaşlarımla uğraşmıyorum, hazır kaşlarla güne başlamak harika!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/621592efea4cbd5bc808ef430d187b1a.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaYLmOXMmWT/',
    originalPrice: 0,
    campaignPrice: 2499,
    campaignTag: '15. Yıla Özel Microblading Kampanyası',
    packageIncludes: ['Microblading Kıl Tekniği', '1 Ay İçindeki Rötuş Dahil', 'Altın Oran Ölçümü', 'Steril Uygulama Ortamı'],
    campaignDescription: "SaloonS Güzellik'te 15. Yıla Özel Efsane Microblading Kampanyası! ⭐✨\n\nHer sabah kaş kalemiyle uğraşmaya, simetriyi tutturmaya çalışmaya son! Doğal kendi kaş kılınızdan ayırt edemeyeceğiniz kusursuz Microblading Kıl Tekniği uygulamamız şimdi çok özel bir fiyatla sizi bekliyor.\n\n\uD83D\uDED1 Sürpriz Ücret Yok, Net Fiyat:\n\nUygulama: Microblading Kıl Tekniği + 1 Ay İçindeki Rötuş Dahil\n\nKampanya Fiyatı: Sadece 2499 TL!\n\nYüz hattınıza en uygun altın oran ölçümüyle, tamamen steril koşullarda hayal ettiğiniz dolgun ve doğal kaşlara kavuşun. \uD83D\uDC8E",
  },
  {
    id: '18',
    customerName: 'Melahat Hanım',
    procedure: 'Yüz Masajı',
    category: 'cilt-bakimi',
    rating: 5,
    comment: "SaloonS Güzellik'in yeni yerinde yüz masajı yaptırdım ve inanılmaz rahatladım! 600 metrekarelik devasa salon, kış bahçesi ve modern hizmetleriyle gerçekten farklı bir deneyim. Yüz masajı sonrası cildim çok daha canlı ve parlak göründü. Personel çok ilgili, hijyen konusunda çok titizler. Kozyatağı metroya 2 dakika mesafede olması da ulaşımı çok kolay. Kesinlikle tekrar geleceğim!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/5d4141f129519de0d4cb23702540686b.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaW-oUUsjZb/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: "15. Yıla Özel Yeni Yerimizde Hizmetinizdeyiz",
    packageIncludes: ['Yüz Masajı', 'Kafa Masajı', 'Vücut Masajı', '600 m² Bay Bayan Tüm Güzellik Hizmetleri', 'Kış Bahçesi', 'Solaryum', 'Yeni Eklenen Birçok Servis'],
    campaignDescription: "15. YILIMIZDA YENI YERIMIZDE 600 METREKARE! ⭐✨\n\nBay Bayan Tüm Güzellik Hizmetlerimizle Hizmetinizdeyiz:\n\n\uD83D\uDC84 Kafa Masajı\n\uD83D\uDC84 Vücut Masajı\n\uD83D\uDC84 Yüz Masajı\n\uD83D\uDC84 Tüm Güzellik Hizmetleri\n\n☀️ Kış Bahçemiz\n☀️ Solaryum\n\uD83D\uDCA1 Yeni Eklediğimiz Bir Çok Servisimiz\n\nTüm bu hizmetlerle 15. yılımızda yeni yerimizde sizleri ağırlamaktan mutluluk duyarız!",
  },
  {
    id: '19',
    customerName: 'Canan Hanım',
    procedure: 'Yüz Masajı',
    category: 'cilt-bakimi',
    rating: 5,
    comment: "SaloonS Güzellik salonunda yüz masajı yaptırdım ve gerçekten bambaşka bir deneyim yaşadım! Uzman eller sayesinde yüzümdeki gerginlik tamamen gitti, cildim çok daha taze ve genç görünüyor. Hijyenik koşullar, profesyonel ekip ve muhteşem salon ambiyansıyla her şey çok güzeldi. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tekrar geleceğim ve herkese tavsiye ediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/cae94760962d2634f7d0192fa032be2d.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaWyd0SswM8/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: "15. Yıla Özel Yeni Yerimizde Hizmetinizdeyiz",
    packageIncludes: ['Yüz Masajı', 'Kafa Masajı', 'Vücut Masajı', '600 m² Bay Bayan Tüm Güzellik Hizmetleri', 'Kış Bahçesi', 'Solaryum', 'Yeni Eklenen Birçok Servis'],
    campaignDescription: "15. YILIMIZDA YENI YERIMIZDE 600 METREKARE! ⭐✨\n\nBay Bayan Tüm Güzellik Hizmetlerimizle Hizmetinizdeyiz:\n\n\uD83D\uDC84 Kafa Masajı\n\uD83D\uDC84 Vücut Masajı\n\uD83D\uDC84 Yüz Masajı\n\uD83D\uDC84 Tüm Güzellik Hizmetleri\n\n☀️ Kış Bahçemiz\n☀️ Solaryum\n\uD83D\uDCA1 Yeni Eklediğimiz Bir Çok Servisimiz\n\nTüm bu hizmetlerle 15. yılımızda yeni yerimizde sizleri ağırlamaktan mutluluk duyarız!",
  },
  {
    id: '20',
    customerName: 'Nurgün Hanım',
    procedure: 'Protez Tırnak + Manikür + Kalıcı Oje',
    category: 'tirnak-bakimi',
    rating: 5,
    comment: "SaloonS Güzellik'te protez tırnak ve manikür paketi yaptırdım, sonuç harika! Tırnaklarım çok doğal ve şık görünüyor, herkes çok beğeniyor. Steril koşullarda, profesyonel ekip tarafından yapılan işlem sırasında hiç rahatsızlık hissetmedim. Kalıcı oje ile renkler haftalarca bozulmadı kalıyor. Ellerim her zaman bakımlı görünüyor, teşekkürler SaloonS!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/270801e88d5e171cedccddc3ef8201a1.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaUpG8IMO-H/',
    originalPrice: 0,
    campaignPrice: 1499,
    campaignTag: '15. Yıla Özel Protez Tırnak Kampanyası',
    packageIncludes: ['Protez Tırnak', 'Manikür', 'Kalıcı Oje', 'Jel Güçlendirme', 'Pedikür Seçeneği'],
    campaignDescription: "15. YILIMIZI ÖZEL PROTEZ TIRNAK KALICI OJE JEL GÜÇLENDIRME MANIKÜR PEDIKÜR KAMPANYALARIMIZI DUYDUNUZ MU? ✨\n\nSaloonS Güzellik'te 15. yıla özel efsane tırnak bakımı kampanyası başladı!\n\n\uD83D\uDC8E Paket İçeriği:\nProtez Tırnak + Manikür + Kalıcı Oje\n\n\uD83D\uDED1 Net Fiyat, Sürpriz Ücret Yok:\nSadece 1499 TL!\n\nAyrıca Jel Güçlendirme ve Pedikür seçenekleriyle tüm el ve ayak bakım ihtiyaçlarınızı tek çatı altında karşılıyoruz. Doğal görünümlü protez tırnaklar, uzun ömürlü kalıcı oje ve profesyonel manikür hizmetimizle hayalinizdeki bakımlı ellere kavuşun!",
  },
  {
    id: '21',
    customerName: 'Sibel Hanım',
    procedure: 'Saç Kaynak',
    category: 'sac',
    rating: 5,
    comment: "SaloonS Güzellik'te saç kaynak yaptırdım ve sonuç inanılmaz! Mikro kaynak tekniği sayesinde saçlarım tamamen doğal görünüyor, hiçbir bağlama izi yok. Uzman ekip sayesinde saçlarım hem uzun hem hacimli oldu, kendi saçımdan ayırt edemiyorsunuz. İşlem sırasında hiç ağrı hissetmedim, steril koşullarda profesyonel bir hizmet aldım. Artık saçlarımla çok daha özgüvenli hissediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/e75f5d93eaedf43afd6ed7d3d83faf07.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaUM6SSsflp/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: '15. Yıla Özel Saç Kaynak Kampanyası',
    packageIncludes: ['Mikro Kaynak', 'Hayalet Kaynak', 'Keratin Kaynak', 'Tüm Saç Uzatma İşlemleri'],
    campaignDescription: "15. YILIMIZI ÖZEL MIKRO KAYNAK HAYALET KAYNAK KERATIN KAYNAK VE TÜM SAÇ UZATMA İŞLEMLERİMİZDE %50 İNDİRİM KAÇIRMAYIN! ✨\n\nSaloonS Güzellik'te 15. yıla özel dev saç kaynak kampanyası başladı!\n\n\uD83D\uDC84 Uygulama Çeşitlerimiz:\n• Mikro Kaynak\n• Hayalet Kaynak\n• Keratin Kaynak\n• Tüm Saç Uzatma İşlemleri\n\n\uD83D\uDD25 15. Yıla Özel:\nTüm Saç Kaynak ve Uzatma İşlemlerinde %50 İNDİRİM!\n\nDoğal görünümlü, saçlarınıza hiç zarar vermeyen tekniklerle hayalinizdeki uzun ve hacimli saçlara kavuşun. Profesyonel uzmanlarımız tarafından, tamamen steril koşullarda uygulanır!",
  },
  {
    id: '22',
    customerName: 'Özlem Hanım',
    procedure: 'Tırnak İşlemleri',
    category: 'tirnak-bakimi',
    rating: 5,
    comment: "SaloonS Güzellik salonunda tırnak işlemleri yaptırdım ve sonuçtan çok memnun kaldım! Profesyonel ekip sayesinde tırnaklarım hem sağlıklı hem çok şık görünüyor. Steril koşullarda yapılan işlem sırasında hiç rahatsızlık hissetmedim, personel çok ilgiliydi. Kalıcı oje uygulamasıyla renkler haftalarca bozulmadı kalıyor. Ellerim her zaman bakımlı ve kusursuz görünüyor. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tavsiye ediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/a2790d7b20d205fa8477d18d8d82bc3a.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaSNKDFDI3s/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: '15. Yıla Özel Tırnak Kampanyası',
    packageIncludes: ['Manikür', 'Pedikür', 'Kalıcı Oje', 'Protez Tırnak', 'Jel Güçlendirme'],
  },
  {
    id: '23',
    customerName: 'Melek Hanım',
    procedure: 'G5 Masajı',
    category: 'bolgesel-incelme',
    rating: 5,
    comment: "SaloonS Güzellik'te G5 masajı yaptırdım ve sonuç inanılmaz! Selülitlerimde gözle görülür fark oluştu, cildim çok daha pürüzsüz ve sıkı görünüyor. Profesyonel ekip tarafından uygulanan işlem sırasında rahatladım, hiç ağrı hissetmedim. Düzenli seanslarla sonuçlar çok daha etkili oluyor. Hijyenik koşullar ve modern salon ortamıyla gerçekten farklı bir deneyim yaşadım. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tekrar geleceğim ve herkese tavsiye ediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/6f12ffe4cd683a43a8a38da7de715974.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaNIFCCM669/',
    originalPrice: 0,
    campaignPrice: 499,
    campaignTag: '15. Yıla Özel G5 Masajı Kampanyası',
    packageIncludes: ['G5 Masajı 1 Seans', 'Bölgesel İncelme Desteği', 'Selülit Tedavisi', 'Profesyonel Uygulama'],
    campaignDescription: "G5 masajını denemek istiyorsan fırsat şu an! ✨\n\n15. yıla özel:\n\n✨ G5 Masajı\n📦 1 Seans\n💰 Sadece 499 TL\n\nDüzenli uygulama ile desteklenen bakım süreci.\n\nKontenjan sınırlı.",
  },
  {
    id: '24',
    customerName: 'Saadet Hanım',
    procedure: 'Solaryum',
    category: 'solaryum',
    rating: 5,
    comment: "SaloonS Güzellik salonunda solaryum deneyimi yaşadım ve çok memnun kaldım! Ergoline marka Alman teknolojisi cihazlar sayesinde canım acımadan, güvenle bronzlaştım. İlk seanstan itibaren cildimde eşit ve doğal bir renk tonu oluştu. Hijyen koşulları mükemmel, personel çok ilgili ve yardımcı. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kışın bile bronz tenimi korumak için ideal!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/256c4f03794f6f494341cbb0815e3b84.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaM5i78Mn_9/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Solaryum Kampanyası',
    packageIncludes: ['50 Dakika Solaryum: 1500 TL', '100 Dakika Solaryum: 2500 TL', "Satın aldığınız paketleri 31 Aralık'a kadar dilediğiniz zaman kullanabilirsiniz!"],
    campaignDescription: "SALOONS'TA SOLARYUM KAMPANYASI BAŞLADI! ☀️💎\n\nErgoline marka muazzam Alman teknolojisiyle, canınız acımadan mükemmel bir bronzluğa kavuşun.\n\n🔥 Sınırlı Süreye Özel Fiyatlar:\n\n50 Dakika Solaryum: 1500 TL\n\n100 Dakika Solaryum: 2500 TL\n(Satın aldığınız paketleri 31 Aralık'a kadar dilediğiniz zaman kullanabilirsiniz!)",
  },
  {
    id: '25',
    customerName: 'Ayça Hanım',
    procedure: 'Dudak Renklendirme',
    category: 'kalici-makyaj',
    rating: 5,
    comment: "SaloonS Güzellik'te dudak renklendirme yaptırdım ve sonuç inanılmaz! Sağlık Bakanlığı onaylı orijinal pigmentler sayesinde dudaklarım tamamen doğal ve canlı görünüyor. Abartılı değil, tam istediğim gibi pembe ton. İşlem sırasında hiç ağrı hissetmedim, hijyenik koşullarda uzman ekip tarafından yapıldı. Sabah kalktığımda hazır makyajlı dudaklarla güne başlamak harika! Arkadaşlarım ne yaptığımı sürekli soruyor, çok beğeniyorlar.",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/ff230550d213333595acf770eb0c86b5.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaMwn62MbJ1/',
    originalPrice: 0,
    campaignPrice: 2999,
    campaignTag: '15. Yıla Özel Dudak Renklendirme Kampanyası',
    packageIncludes: ['Dudak Renklendirme', '1 Ay İçindeki Rötuş Dahil', 'Sağlık Bakanlığı Onaylı Orijinal Pigmentler', 'Hijyenik Uygulama'],
    campaignDescription: "🛑 Sürpriz Ücret Yok, Net Fiyat:\n\nUygulama: Dudak Renklendirme + 1 Ay İçindeki Rötuş Dahil\n\nKampanya Fiyatı: Sadece 2999 TL!\n\nSağlık Bakanlığı onaylı orijinal pigmentler ve uzman kadromuzla, tamamen hijyenik koşullarda hayal ettiğiniz kalıcı canlılığa kavuşun. 🌟",
  },
  {
    id: '26',
    customerName: 'Ferhat Bey',
    procedure: 'Erkek Kuaför İşlemleri',
    category: 'sac',
    rating: 5,
    comment: "SaloonS Güzellik & Solaryum'da erkek kuaför hizmeti aldım ve çok memnun kaldım! Profesyonel ekip tarafından yapılan saç kesimi ve bakım sonrası çok şık ve modern bir görünüme kavuştum. Salon hijyenik koşulları mükemmel, personel çok ilgili. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Bay bayan tüm güzellik hizmetlerini tek çatı altında bulabileceğiniz harika bir salon!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/79e93a8084a59069e32d23a1bd07ef07.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaMrt3OsxlM/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Erkek Kuaför Hizmetleri',
    packageIncludes: ['Erkek Saç Kesimi', 'Sakal Düzeltme', 'Saç Bakımı', 'Profesyonel Uygulama'],
    campaignDescription: "SaloonS Güzellik & Solaryum'da Erkek Kuaför Hizmetleri! ✨\n\nProfesyonel kadromuz ve modern salonumuzda, erkekler için özel saç kesimi, sakal düzeltme ve bakım hizmetleri sunuyoruz.\n\n📍 Kozyatağı Metroya 2 Dakika Mesafe\n\nBay bayan tüm güzellik hizmetlerimizle 600 m² yeni yerimizde hizmetinizdeyiz!",
  },
  {
    id: '27',
    customerName: 'Lara Hanım',
    procedure: 'Kafa Masajı',
    category: 'kafa-masaji',
    rating: 5,
    comment: "SaloonS Güzellik'te kafa masajı yaptırdım ve gerçekten bambaşka bir deneyim yaşadım! Günün tüm stresi ve gerginliği 40 dakikalık bu özel ritüel sonrası tamamen gitti. Scalp fırçası ve lenf drenaj masajıyla saç derim adeta yenilendi, saçlarım daha parlak ve hafif görünüyor. Nem ve onarım odaklı son dokunuşlar muhteşemdi. Uzman eller sayesinde hiç rahatsızlık hissetmedim. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tekrar geleceğim ve herkese tavsiye ediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/724b6f62d17ef76583f44ab7848492a5.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaJGibmM5RC/',
    originalPrice: 0,
    campaignPrice: 999,
    campaignTag: '15. Yıla Özel Kafa Masajı Kampanyası',
    packageIncludes: ['Arındırıcı Scalp Uygulaması', 'Yumuşak Scalp Fırçası & Özel Masaj Teknikleri', 'Lenf Drenaj Masajı', 'Nem ve Onarım Odağı', '40 Dakika Seans'],
    campaignDescription: "Zihninizi Susturun, Saç Derinizi Yenileyin: SaloonS Head Spa Ritüeli! ✨💆\u200D♀️\n\nGünün tüm stresini ve gerginliğini geride bırakmaya hazır mısınız? 15. yılımıza özel hazırladığımız arındırıcı kafa masajı seansıyla tepeden tırnağa hafiflediğinizi hissedeceksiniz. 🌟\n\n🔮 40 Dakikalık Bu Benzersiz Ritüelde Neler Var?\n\nArındırıcı Scalp Uygulaması: Saç diplerini nazikçe temizleyen özel bakım.\n\nYumuşak Scalp Fırçası & Özel Masaj Teknikleri: Saç derisini rahatlatırken ürünlerin etkisini maksimuma çıkaran dokunuşlar.\n\nLenf Drenaj Masajı: Yüz ve kafa bölgesindeki tüm gerginliği hafifleten derin rahatlama.\n\nNem ve Onarım Odağı: Saç tellerini besleyen, saçlara parlaklık ve hafiflik kazandıran son dokunuşlar.\n\n💥 15. Yıla Özel Dev Fırsat:\n⏱️ 40 Dakikalık Kafa Masajı Seansı Sadece 999 TL!",
  },
  {
    id: '28',
    customerName: 'Kübra Hanım',
    procedure: 'Manikür',
    category: 'tirnak-bakimi',
    rating: 5,
    comment: "SaloonS Güzellik salonunda manikür yaptırdım ve çok memnun kaldım! Profesyonel ekip sayesinde tırnaklarım hem sağlıklı hem çok şık görünüyor. Steril koşullarda yapılan işlem sırasında hiç rahatsızlık hissetmedim, personel çok ilgiliydi. Kalıcı oje uygulamasıyla renkler haftalarca bozulmadı kalıyor. Ellerim her zaman bakımlı ve kusursuz görünüyor. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tavsiye ediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/7ca9b84ddf443a26bb35a801cc2b9d90.png',
    videoUrl: '',
    date: '2026-07-07',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaBKrtgsKfy/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Manikür Hizmetleri',
    packageIncludes: ['Manikür', 'Profesyonel Uygulama', 'Hijyenik Koşullar', 'Kalıcı Oje Seçeneği'],
    campaignDescription: "SaloonS Güzellik'te Profesyonel Manikür Hizmetleri! ✨\n\nEllerinize hak ettiği özeni gösteriyoruz. Hijyenik koşullarda, uzman ekibimiz tarafından yapılan manikür hizmetlerimizle elleriniz hem sağlıklı hem bakımlı görünecek.\n\n💅 Hizmetlerimiz:\n• Klasik Manikür\n• SPA Manikür\n• Kalıcı Oje\n• Nail Art\n\n📍 Kozyatağı Metroya 2 Dakika Mesafe\n\nRandevu için bizi arayın!",
  },
  {
    id: '29',
    customerName: 'Ayşe Hanım',
    procedure: 'Solaryum',
    category: 'solaryum',
    rating: 5,
    comment: "SaloonS Güzellik salonunda solaryum yaptırdım ve sonuçtan çok memnun kaldım! Ergoline marka cihazlarla güvenle bronzlaştım, cildimde eşit ve doğal bir renk tonu oluştu. Hijyen koşulları mükemmel, personel her zaman ilgili ve yardımcı. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kışın bile bronz tenimi korumak için ideal bir adres!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/69215b8f6d076122f4cb3efa4902d8ca.png',
    videoUrl: '',
    date: '2026-07-08',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DaAaj-EsrkY/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Solaryum Kampanyası',
    packageIncludes: ['50 Dakika Solaryum: 1500 TL', '100 Dakika Solaryum: 2500 TL', "Satın aldığınız paketleri 31 Aralık'a kadar dilediğiniz zaman kullanabilirsiniz!"],
    campaignDescription: "SALOONS'TA SOLARYUM KAMPANYASI BAŞLADI! ☀️💎\n\nErgoline marka muazzam Alman teknolojisiyle, canınız acımadan mükemmel bir bronzluğa kavuşun.\n\n🔥 Sınırlı Süreye Özel Fiyatlar:\n\n50 Dakika Solaryum: 1500 TL\n\n100 Dakika Solaryum: 2500 TL\n(Satın aldığınız paketleri 31 Aralık'a kadar dilediğiniz zaman kullanabilirsiniz!)",
  },
  {
    id: '30',
    customerName: 'İlkay Hanım',
    procedure: 'G5 Lenf Drenaj',
    category: 'bolgesel-incelme',
    rating: 5,
    comment: "SaloonS Güzellik'te G5 lenf drenaj hizmeti aldım ve sonuç inanılmaz! Vücuttaki ödem tamamen gitti, cildim çok daha pürüzsüz ve sıkı görünüyor. Lenf drenaj masajıyla kan dolaşımım hızlandı, kendimi çok daha hafif hissediyorum. Profesyonel ekip tarafından uygulanan işlem sırasında rahatladım, hiç ağrı hissetmedim. Hijyenik koşullar ve modern salon ortamıyla gerçekten farklı bir deneyim yaşadım. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tekrar geleceğim ve herkese tavsiye ediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/b7ee237c8dae4ce78a542ade7c4e5eaa.png',
    videoUrl: '',
    date: '2026-07-08',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DZytFP_MFn2/',
    originalPrice: 0,
    campaignPrice: 499,
    campaignTag: '15. Yıla Özel G5 Lenf Drenaj Kampanyası',
    packageIncludes: ['G5 Lenf Drenaj 1 Seans', 'Ödem Atma Desteği', 'Kan Dolaşımı Hızlandırma', 'Profesyonel Uygulama'],
    campaignDescription: "G5 Lenf Drenaj ile ödemden kurtulun! ✨\n\n15. yıla özel:\n\n✨ G5 Lenf Drenaj\n📦 1 Seans\n💰 Sadece 499 TL\n\nDüzenli uygulama ile desteklenen bakım süreci.\n\nKontenjan sınırlı.",
  },
  {
    id: '31',
    customerName: 'Gülgün Hanım',
    procedure: 'Microblading',
    category: 'kalici-makyaj',
    rating: 5,
    comment: "SaloonS Güzellik'te microblading yaptırdım ve sonuç inanılmaz! Kıl tekniği sayesinde kaşlarım tamamen doğal görünüyor, kendi kılınızdan ayırt edemeyeceksiniz. Steril koşullarda, profesyonel ellerde hiç ağrı hissetmedim. Altın oran ölçümüyle yüz hattıma en uygun şekil verildi. Sabah kalktığımda hazır kaşlarla güne başlamak paha biçilmez! Herkes çok beğeniyor, kesinlikle tavsiye ederim.",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/73ad925079b03f40f1b1616a5c4a8dee.png',
    videoUrl: '',
    date: '2026-07-08',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DZxt2BeMhZx/',
    originalPrice: 0,
    campaignPrice: 2499,
    campaignTag: '15. Yıla Özel Microblading Kampanyası',
    packageIncludes: ['Microblading Kıl Tekniği', '1 Ay İçindeki Rötuş Dahil', 'Altın Oran Ölçümü', 'Steril Uygulama Ortamı'],
    campaignDescription: "SaloonS Güzellik'te 15. Yıla Özel Efsane Microblading Kampanyası! ⭐✨\n\nHer sabah kaş kalemiyle uğraşmaya, simetriyi tutturmaya çalışmaya son! Doğal kendi kaş kılınızdan ayırt edemeyeceğiniz kusursuz Microblading Kıl Tekniği uygulamamız şimdi çok özel bir fiyatla sizi bekliyor.\n\n🛑 Sürpriz Ücret Yok, Net Fiyat:\n\nUygulama: Microblading Kıl Tekniği + 1 Ay İçindeki Rötuş Dahil\n\nKampanya Fiyatı: Sadece 2499 TL!\n\nYüz hattınıza en uygun altın oran ölçümüyle, tamamen steril koşullarda hayal ettiğiniz dolgun ve doğal kaşlara kavuşun. 💎",
  },
  {
    id: '32',
    customerName: 'Latife Hanım',
    procedure: 'Pedikür',
    category: 'tirnak-bakimi',
    rating: 5,
    comment: "SaloonS Güzellik salonunda pedikür yaptırdım ve sonuçtan çok memnun kaldım! Profesyonel ekip sayesinde ayaklarım hem sağlıklı hem çok bakımlı görünüyor. Steril koşullarda yapılan işlem sırasında hiç rahatsızlık hissetmedim, personel çok ilgiliydi. Kalıcı oje uygulamasıyla renkler haftalarca bozulmadı kalıyor. Ayaklarım her zaman bakımlı ve kusursuz görünüyor. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tavsiye ediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/f685843e758b01fe6123f8613856d9e2.png',
    videoUrl: '',
    date: '2026-07-08',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DZxrUR9MnTJ/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Pedikür Hizmetleri',
    packageIncludes: ['Pedikür', 'Profesyonel Uygulama', 'Hijyenik Koşullar', 'Kalıcı Oje Seçeneği'],
    campaignDescription: "SaloonS Güzellik'te Profesyonel Pedikür Hizmetleri! ✨\n\nAyaklarınıza hak ettiği özeni gösteriyoruz. Hijyenik koşullarda, uzman ekibimiz tarafından yapılan pedikür hizmetlerimizle ayaklarınız hem sağlıklı hem bakımlı görünecek.\n\n💅 Hizmetlerimiz:\n• Klasik Pedikür\n• Medikal Pedikür\n• SPA Pedikür\n• Kalıcı Oje Seçenekleri\n\n📍 Kozyatağı Metroya 2 Dakika Mesafe\n\nRandevu için bizi arayın!",
  },
  {
    id: '33',
    customerName: 'Zeliha Hanım',
    procedure: 'Cilt Bakımı & Zayıflama',
    category: 'cilt-bakimi',
    rating: 5,
    comment: "SaloonS Güzellik salonunda hem cilt bakımı hem zayıflama hizmeti aldım ve sonuçtan çok memnun kaldım! Cildim çok daha canlı ve parlak görünüyor, aynı zamanda bölgesel incelme desteğiyle forma girdim. Profesyonel ekip sayesinde her iki işlem de çok konforlu geçti. Hijyenik koşullar ve modern salon ortamı gerçekten fark yaratıyor. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tekrar geleceğim!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/dd3ba5e3b2a563a74903fa14ebb9e96c.png',
    videoUrl: '',
    date: '2026-07-08',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DZu5j-gsn1r/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Cilt Bakımı & Zayıflama Hizmetleri',
    packageIncludes: ['Profesyonel Cilt Bakımı', 'Bölgesel İncelme Desteği', 'Hydrafacial Seçeneği', 'Cilt Analizi'],
    campaignDescription: "SaloonS Güzellik'te Cilt Bakımı & Zayıflama Hizmetleri! ✨\n\nCildinize ve vücudunuza aynı anda özen gösteriyoruz. Profesyonel cilt bakımı uygulamalarımızla cildiniz canlanırken, bölgesel incelme desteğiyle de formunuza kavuşun.\n\n💆‍♀️ Hizmetlerimiz:\n• Hydrafacial Cilt Bakımı\n• Ozon Terapi\n• Medikal Maske\n• Bölgesel İncelme Desteği\n• Cilt Analizi\n\n📍 Kozyatağı Metroya 2 Dakika Mesafe\n\nRandevu için bizi arayın!",
  },
  {
    id: '34',
    customerName: 'Yasemin Hanım',
    procedure: 'Cımbız Epilasyon',
    category: 'lazer-epilasyon',
    rating: 5,
    comment: "SaloonS Güzellik salonunda cımbız epilasyon hizmeti aldım ve sonuçtan çok memnun kaldım! Profesyonel ekip sayesinde tüylerim tamamen temizlendi, cildim pürüzsüz ve yumuşak oldu. Steril koşullarda yapılan işlem sırasında hiç rahatsızlık hissetmedim, personel çok ilgiliydi. Cımbız epilasyon sayesinde inatçı tüylerden kurtuldum. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tavsiye ediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/c0dbf49414b5a94e7b78b032944f7043.png',
    videoUrl: '',
    date: '2026-07-08',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DZu38aFsxDC/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Cımbız Epilasyon Hizmetleri',
    packageIncludes: ['Cımbız Epilasyon', 'Profesyonel Uygulama', 'Hijyenik Koşullar', 'Cilt Nemlendirme'],
    campaignDescription: "SaloonS Güzellik'te Profesyonel Cımbız Epilasyon Hizmetleri! ✨\n\nCildinize zarar vermeden, inatçı tüylerden kurtulun. Hijyenik koşullarda, uzman ekibimiz tarafından yapılan cımbız epilasyon hizmetlerimizle pürüzsüz bir cilde kavuşun.\n\n✨ Hizmetlerimiz:\n• Cımbız Epilasyon\n• Cilt Nemlendirme\n• Profesyonel Uygulama\n• Hijyenik Koşullar\n\n📍 Kozyatağı Metroya 2 Dakika Mesafe\n\nRandevu için bizi arayın!",
  },
  {
    id: '35',
    customerName: 'Melisa Hanım',
    procedure: 'Saç Kesim',
    category: 'sac',
    rating: 5,
    comment: "SaloonS Güzellik salonunda saç kesim yaptırdım ve sonuçtan çok memnun kaldım! Profesyonel ekip sayesinde saçlarım hem şık hem çok bakımlı görünüyor. Yüz hatlarıma uygun kesim ve şekillendirme sayesinde çok daha modern bir görünüme kavuştum. Steril koşullarda yapılan işlem sırasında personel çok ilgiliydi. Kozyatağı metroya sadece 2 dakika mesafe, ulaşım çok kolay. Kesinlikle tavsiye ediyorum!",
    thumbnailUrl: 'https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/7d60d90a54810007f4648890f4f1dd68.png',
    videoUrl: '',
    date: '2026-07-08',
    location: 'İstanbul, Türkiye',
    instagramUrl: 'https://www.instagram.com/p/DZuw7tvMsJj/',
    originalPrice: 0,
    campaignPrice: 0,
    campaignTag: 'Saç Kesim Hizmetleri',
    packageIncludes: ['Profesyonel Saç Kesimi', 'Saç Şekillendirme', 'Balyaj & Renklendirme', 'Keratin & Bakım'],
    campaignDescription: "SaloonS Güzellik'te Profesyonel Saç Kesim Hizmetleri! ✨\n\nSaçlarınıza hak ettiği özeni gösteriyoruz. Uzman kadromuz tarafından, yüz hatlarınıza uygun profesyonel saç kesimi ve şekillendirme hizmetleriyle her zaman şık ve bakımlı görünün.\n\n💇‍♀️ Hizmetlerimiz:\n• Profesyonel Saç Kesimi\n• Saç Şekillendirme\n• Balyaj & Renklendirme\n• Keratin & Bakım\n\n📍 Kozyatağı Metroya 2 Dakika Mesafe\n\nRandevu için bizi arayın!",
  },
];